import axios from "axios";
import router from "../router";

const apiUrl = process.env.VUE_APP_API_URL;
const apiClient = axios.create({
  baseURL: apiUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

export default {
  setToken() {
    const token = window.localStorage.getItem("token");
    if (token !== null) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    } else {
      delete axios.defaults.headers.common["Authorization"];
    }
  },

  loginRequest(user, password) {
    return apiClient.post("/login", {
      username: user,
      password: password
    });
  },
  logoutRequest() {
    this.setToken();
    return apiClient.post("/logout").catch(error => {
      if (error.response.status !== 401) {
        throw error;
      }
    });
  },
  login(user, password) {
    return this.loginRequest(user, password).then(({ data }) => {
      window.localStorage.setItem("token", data.token);
      window.localStorage.setItem("user", JSON.stringify(data.user));
      this.setToken();
      return data.user;
    });
  },
  logout() {
    return this.logoutRequest().then(() => {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("user");
      delete axios.defaults.headers.common["Authorization"];
    });
  },

  // ------- User profile ---

  getUserProfile() {
    this.setToken();
    return apiClient.get("/profile").catch(error => {
      if (error.response.status == 401) {
        router.push("/login");
      } else {
        throw error;
      }
    });
  },
  updateUserProfile(profile) {
    this.setToken();
    return apiClient.put("/profile", profile);
  },
  getProfileOptions() {
    this.setToken();
    return apiClient.get("/profile/options");
  },
  // ------- Texts ----------

  getTexts() {
    return apiClient.get("/text");
  },

  // ------- Offers ----------

  getOffers() {
    this.setToken();
    return apiClient.get("/offer").catch(error => {
      if (error.response.status == 401) {
        router.push("/login");
      } else {
        throw error;
      }
    });
  },
  getMyOffers() {
    this.setToken();
    return apiClient.get("/offer/mine");
  },
  cancelOffer(id) {
    this.setToken();
    return apiClient.post("/offer/cancel/" + id);
  },

  // ------- Reactions ----------

  postReaction(reaction) {
    this.setToken();
    return apiClient.post("/reaction/create", reaction);
  },
  confirmReaction(id) {
    this.setToken();
    return apiClient.post("/reaction/confirm/" + id);
  },

  // ------- Appointments ----------
  getLocations() {
    this.setToken();
    return apiClient.get("/locations");
  },
  getRooms() {
    this.setToken();
    return apiClient.get("/rooms");
  },
  getAppointments() {
    this.setToken();
    return apiClient.get("/appointments");
  },
  getAppointment(id) {
    this.setToken();
    return apiClient.get("/appointment/" + id);
  },
  deleteAppointment(id) {
    this.setToken();
    return apiClient.delete("/appointment/" + id);
  },
  updateAppointment(id, { comment }) {
    this.setToken();
    return apiClient.post("/appointment/" + id, { comment });
  },
  getReservations() {
    this.setToken();
    return apiClient.get("/reservations");
  },
  getReservation(id) {
    this.setToken();
    return apiClient.get("/appointment/" + id);
  },
  deleteReservation(id) {
    this.setToken();
    return apiClient.delete("/appointment/" + id);
  },
  updateReservation(id, { comment }) {
    this.setToken();
    return apiClient.post("/appointment/" + id, { comment });
  },
  getMaterials() {
    this.setToken();
    return apiClient.get("/materials");
  },
  searchAppointmentSuggestions(payload) {
    this.setToken();
    return apiClient.post("/planner/suggestions", payload).catch(error => {
      console.log(error);
    });
  },
  confirmAppointment(payload) {
    this.setToken();
    return apiClient
      .post("/planner/create", payload)
      .catch(error => {
        console.log("what is the error?", error);
      });
  },
  searchReservationSuggestions(payload) {
    this.setToken();
    return apiClient
      .post("/reservation/suggestions", payload)
      .catch(error => {
        console.log(error);
      });
  },
  confirmReservation(payload) {
    this.setToken();
    return apiClient.post("/reservation/create", payload);
  }
};
